import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import appConfig, { getPortalKey } from "../config";
import { Mail, Phone } from "lucide-react";

const ContactUs = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const authStatus = sessionStorage.getItem("isAuthenticated");
    setIsAuthenticated(authStatus === "true");
  }, []);

  const config = useMemo(() => {
    const key = getPortalKey();
    return appConfig[key] || appConfig.portal;
  }, []);

  const [appName] = React.useState(config.name);
  const [appLogo] = React.useState(config.logo);

  return (
    <div className="flex flex-col h-screen">
      {/* Header - Only show when authenticated */}
      {isAuthenticated && (
        <div className="fixed top-0 left-0 w-full z-50 bg-primary">
          <Header />
        </div>
      )}

      {/* Main Layout (Sidebar + Content) */}
      <div className={`flex flex-1 ${isAuthenticated ? "mt-[72px]" : ""}`}>
        {/* Sidebar - Only show when authenticated */}
        {isAuthenticated && (
          <div className="fixed left-0 w-64 bg-white shadow-md h-[calc(100vh-72px)] overflow-y-auto hidden lg:block">
            <Sidebar />
          </div>
        )}

        <main className={`flex-1 bg-gray-100 overflow-y-auto flex flex-col items-center ${isAuthenticated ? "lg:ml-64" : ""}`}>
          {/* Back to Login button - Only show when not authenticated */}
          {!isAuthenticated && (
            <div className="w-full max-w-4xl px-4 pt-6">
              <button
                onClick={() => navigate("/login")}
                className="text-primary hover:text-secondary font-medium underline mb-4"
              >
                ← Back to Login
              </button>
            </div>
          )}

          <div className={`bg-white rounded-xl overflow-hidden shadow-xl max-w-4xl mx-auto p-8 w-full ${isAuthenticated ? "mt-10" : "mt-6"}`}>
            {/* Logo */}
            <div className="flex justify-center mb-8">
              <img src={appLogo} alt="Logo" className="w-32 h-auto" />
            </div>

            {/* Page Title */}
            <div className="flex items-center justify-center gap-3 mb-8">
              <div className="w-12 h-1 bg-primary"></div>
              <h1 className="text-3xl font-bold text-gray-800">Contact Us</h1>
              <div className="w-12 h-1 bg-primary"></div>
            </div>

            {/* Contact Information Card */}
            <div className="bg-gray-50 rounded-lg p-8 shadow-md">
              <p className="text-lg text-gray-700 mb-6 text-center">
                For assistance or questions regarding your demographic information please contact Program Compliance
              </p>

              {/* Contact Details */}
              <div className="flex flex-col items-center gap-6">
                {/* Phone */}
                <div className="flex items-center gap-4 bg-white rounded-lg p-4 shadow-sm w-full max-w-md">
                  <div className="bg-primary/10 p-3 rounded-full">
                    <Phone className="w-6 h-6 text-primary" />
                  </div>
                  <div className="flex-1">
                    <p className="text-sm text-gray-500 mb-1">Phone</p>
                    <a
                      href="tel:907-463-7146"
                      className="text-lg font-semibold text-gray-800 hover:text-primary transition-colors"
                    >
                      907-463-7146
                    </a>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-center gap-4 bg-white rounded-lg p-4 shadow-sm w-full max-w-md">
                  <div className="bg-primary/10 p-3 rounded-full">
                    <Mail className="w-6 h-6 text-primary" />
                  </div>
                  <div className="flex-1">
                    <p className="text-sm text-gray-500 mb-1">Email</p>
                    <a
                      href="mailto:enrollment@tlingitandhaida.gov"
                      className="text-lg font-semibold text-gray-800 hover:text-primary transition-colors break-all"
                    >
                      enrollment@tlingitandhaida.gov
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ContactUs;
